import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { AuthDirective } from './auth-base.directive';

@Directive({
  selector: '[appAuthIfAny]',
})
export class AuthIfAnyDirective extends AuthDirective {
  @Input()
  set appAuthIfAny(values: string[]) {
    const result = values.some((val) =>
      this.hasPermission(val, this.authenticationService),
    );
    if (result) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authenticationService: AuthenticationService,
  ) {
    super();
  }
}
